module.exports = __webpack_public_path__ + "static/flower_maroon-7056539b553ac7645bb312e0a27f4a87.png";